import PropTypes from "prop-types";

// react-intl
import { useIntl } from "react-intl";
import translations from "utils/translations";

// react mui
import { Typography } from "@mui/material";

// components
import { Link } from "components";

// constants
import { SCHEDULE_EVENT_APPOINTMENT_DETAIL } from "constants/routes";
import { calendarDialogActions } from "constants/enums";

// styled components
import { SlotWrapper, DeleteAvailabilityWrapper } from "./ApprovedSlot.styles";

const ApprovedSlot = ({
  setSelectedSlot,
  setOpen,
  slot,
  event,
  setAction,
  appointment,
}) => {
  const intl = useIntl();
  const i18n = translations.Agenda(intl).slots.approvedSlot;

  const handleDeleteAppointment = e => {
    e.stopPropagation();
    setSelectedSlot(appointment);
    setAction(calendarDialogActions.DELETEAPPOINTMENT);
    setOpen(true);
  };

  return (
    <SlotWrapper>
      <DeleteAvailabilityWrapper onClick={handleDeleteAppointment}>
        ⨯
      </DeleteAvailabilityWrapper>
      <Link
        to={SCHEDULE_EVENT_APPOINTMENT_DETAIL}
        state={{
          slot: { ...appointment },
          event: { ...event },
        }}
        style={{ flex: 1, textDecoration: "none" }}
      >
        <Typography lineHeight={1.1} fontSize={10}>
          <b>{appointment.toDisplayName}</b> - {i18n.label}
          <br />
          {slot.fromDisplayName}
        </Typography>
      </Link>
    </SlotWrapper>
  );
};
ApprovedSlot.propTypes = {
  setSelectedSlot: PropTypes.func,
  setOpen: PropTypes.func,
  setAction: PropTypes.func,
  slot: PropTypes.object,
  event: PropTypes.object,
  appointment: PropTypes.object,
};
export { ApprovedSlot };
